import { render, staticRenderFns } from "./afterSubmit.vue?vue&type=template&id=10be463e&scoped=true"
import script from "./afterSubmit.vue?vue&type=script&lang=js"
export * from "./afterSubmit.vue?vue&type=script&lang=js"
import style0 from "./afterSubmit.vue?vue&type=style&index=0&id=10be463e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10be463e",
  null
  
)

export default component.exports